import moment from "moment";
import DataTable from "../component/dataTable";
import DeleteModal from "../component/deleteModal";
import { useCacheCustomers } from "../component/hook";
import MainLayout from "../layout/main";
import { findCustomer } from "../service/cache";
import { getRentals } from "../service/callAPI";
import Schema from "../type/schema";

export default function DeletedRentalList() {
	const { isLoading: isCatchingCustomers } = useCacheCustomers();

	return (
		<MainLayout
			pageTitle="Đơn Thuê Đã Xóa"
			title="Đơn Thuê Đã Xóa"
			subTitle="Danh sách các đơn thuê đã xóa. "
		>
			{!isCatchingCustomers && (
				<DataTable
					name="Danh sách đơn thuê đã xóa"
					fetcher={getRentals}
					converter={converter}
					mapFields={{
						"Ngày Xoá": "updatedAt",
						"Khách hàng": "customerId",
						"Trạng thái": "isDone",
						"Số sản phẩm": "itemLength",
						"Tổng phí": "totalFee",
						"Ngày lên đơn": "createdAt",
						"Ngày thuê": "startDate",
						"Ngày trả": "dueDate",
						"Ghi chú": "note"
					}}
					editPath="/rental"
					deletePath="/api/rentals"
					accessor="rentals"
					actionAble={false}
					isGetDeleted
				/>
			)}
			<DeleteModal />
		</MainLayout>
	);
}

function converter(data: Schema.Rental[]): any[] {
	const now = new Date().valueOf() / 1000;

	return data.map((rental) => {
		const isDone = rental.isDone ? (
			<span className="text-success">Hoàn thành</span>
		) : (
			<span className="text-warning">Đang thuê</span>
		);

		const createdAt = moment.unix(+rental.createdAt).format("YYYY-MM-DD");
		const startDate = moment.unix(+rental.startDate).format("YYYY-MM-DD");
		const updatedAt = moment.unix(+rental.updatedAt).format("YYYY-MM-DD");

		const overdue = +rental.dueDate <= now && !rental.isDone ? true : false;
		const dueDate = (
			<span className={overdue ? "text-danger" : ""}>
				{moment.unix(+rental.dueDate).format("YYYY-MM-DD")}
			</span>
		);

		const itemLength = rental.items.length;

		const customer = (
			<a href={`/customer/${rental.customerId}`}>
				{findCustomer(rental.customerId)?.name}
			</a>
		);

		return {
			...rental,
			itemLength,
			isDone,
			createdAt,
			startDate,
			dueDate,
			updatedAt,
			customerId: customer
		};
	});
}
